import PropTypes from 'prop-types';
import cn from 'classnames';

import css from 'styles/components/account/vipDashboard/perksAndPoints.scss';

export const PerksAndPoints = ({ isPerksOnly = false }, { testId }) => (
  <div className={css.pointsAndPerks} data-test-id={testId('vipDashboardPointsAndPerks')}>
    <h2>Key VIP Perks</h2>
    <div className={cn(css.row, { [css.asColumn]: isPerksOnly })}>
      <div className={css.nextDay}>
        <dl>
          <dt>Get FREE Next Business Day Shipping</dt>
          <dd>We'll upgrade your shipping every single time - no strings attached, no minimum purchase!</dd>
        </dl>
      </div>
      <div className={css.refunds}>
        <dl>
          <dt>Enjoy Rapid Refunds</dt>
          <dd>As soon as UPS scans your package, we’ll start your refund, so you get your money back faster!</dd>
        </dl>
      </div>
    </div>
    { !isPerksOnly && <>
    <h2>Ways to Earn Points</h2>
    <div className={css.row}>
      <div className={css.earnPoints}>
        <dl>
          <dt>Earn 1 Point per $1 Spent</dt>
          <dd>Get points you can redeem for VIP codes + be on the lookout for ways to earn bonus points!</dd>
        </dl>
      </div>
      <div className={css.prime}>
        <dl>
          <dt>Rack Up Points Faster</dt>
          <dd>Link your Amazon Prime membership to earn 2 points per $1 spent on Zappos!</dd>
        </dl>
      </div>
    </div>
    <div className={css.row}>
      <div className={css.earnBig}>
        <dl>
          <dt>Earn Big Without Spending</dt>
          <dd>Get 5 points per day for logging in and 10 points for reviewing items you’ve bought!</dd>
        </dl>
      </div>
      <div className={css.bonus}>
        <dl>
          <dt>Bonus Points of Select Brands</dt>
          <dd>Shop selected brands during promotions to earn double points are more!</dd>
        </dl>
      </div>
    </div>
    </>
    }
  </div>
);

PerksAndPoints.contextTypes = {
  testId: PropTypes.func
};

export default PerksAndPoints;
